import { render, staticRenderFns } from "./TableHeaderView.vue?vue&type=template&id=a456a642&scoped=true"
import script from "./TableHeaderView.vue?vue&type=script&lang=js"
export * from "./TableHeaderView.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderView.vue?vue&type=style&index=0&id=a456a642&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456a642",
  null
  
)

export default component.exports